module.exports = __webpack_public_path__ + "static/media/collections-mobile.baeabd1b.svg";